// reducers/agentReducer.ts
import {
    EDIT_KEY_KNOW_REQUEST,
    EDIT_KEY_KNOW_SUCCESS,
    EDIT_KEY_KNOW_FAILURE
} from '../../actions';


const initialState = {
    loading: false,
    data: [],
    error: '',
  };

const editKnowReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case EDIT_KEY_KNOW_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case EDIT_KEY_KNOW_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            };
        case EDIT_KEY_KNOW_FAILURE:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.error
            };
        default:
            return state;
    }
};

export default editKnowReducers;
